;(function($){

    function Commissions() {
        var _                = this;         
        var data             = new FormData();
        _.API                = $("#app_url").val() + "/api/";
        _.oCommissions       = $("input[name='commissions[]']");
        _.total_value        = parseFloat(0);
        _.total_value_close  = parseFloat(0);
        _.total_value_open   = parseFloat(0);

        $.ajaxSetup({
          headers:{
            'Accept' : "application/json",
            'Authorization': "Bearer "+$('meta[name="app-token"]').attr('content'),
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
          }
        }); 

        $("#commissions-legend").on("click", function(e){
            e.preventDefault();

            swal({
              type: 'info',
              html:
                '<div style="text-align: left; max-width: 150px; margin: 0 auto;"><i class="fa fa-circle" style="color: #4db300;"></i> Não Faturado </br>' +
                '<i class="fa fa-circle" style="color: #c33434;"></i> Faturado </br>',
              showCloseButton: true,
              showCancelButton: false,
              focusConfirm: false,
              confirmButtonColor: '#0b7789',
              confirmButtonText:
                'Fechar'
            });
        });  

        $("input#commissionsAll").on("change", function(e){
            $(this).is(':checked') ? _.checkAll() : _.UnCheckAll();
        });

        $("input[name='commissions[]']").on("change", function(e){

            if($("input[name='commissions[]']:checked").length == 0) {
                window.location.reload(true);
            }
            
            _.total(this, $(this).is(':checked'));
        }); 
    } 

    Commissions.prototype.checkAll = function() {
        var _ =  this;

        _.oCommissions.each(function( index, value) {
           $(value).prop('checked', true);
           _.total(value, true);
        });
    };

    Commissions.prototype.UnCheckAll = function() {
        var _ =  this;

        _.oCommissions.each(function( index, value) {
           $(value).prop('checked', false);
           window.location.reload(true);
        });
    };

    Commissions.prototype.total = function(item, isSum) {
        var _                  = this;
        var ntotal_value       = 0;
        var ntotal_value_close = 0;
        var ntotal_value_open  = 0;
        var a_commissions      = [];

        if (isSum) {
            _.total_value       += parseFloat($(item).data('total'));
            _.total_value_close += parseFloat($(item).data('close-total'));
            _.total_value_open  += parseFloat($(item).data('opened-total'));
        } else {
            _.total_value       -= parseFloat($(item).data('total'));
            _.total_value_close -= parseFloat($(item).data('close-total'));
            _.total_value_open  -= parseFloat($(item).data('opened-total'));
        }

        ntotal_value       = _.total_value;
        ntotal_value_close = _.total_value_close;
        ntotal_value_open  = _.total_value_open;
        
        ntotal_value       =  ntotal_value.toFixed(2);
        ntotal_value_close =  ntotal_value_close.toFixed(2);
        ntotal_value_open  =  ntotal_value_open.toFixed(2);
        
        ntotal_value       =  ntotal_value.replace('.',',');
        ntotal_value_close =  ntotal_value_close.replace('.',',');
        ntotal_value_open  =  ntotal_value_open.replace('.',',');


        $(".title-total-value").text(ntotal_value);        
        $(".title-total-value-close").text(ntotal_value_close);
        $(".title-total-value-open").text(ntotal_value_open);

        $.each($("input[name='commissions[]']:checked"), function(idex, value) {
            a_commissions.push($(value).val());
        }); 

        $.each($("#links a"), function(idex, value) {
            var href  = new URL($(value).attr('href'));
            href.searchParams.set('a_commissions', a_commissions);
            $(value).attr('href', href);
        });        
    };

   	new Commissions();

}(jQuery));
 
 
 
 
